import React, { FC } from 'react';
import { HorizontalPaddingLayout } from '@/layouts/HorizontalPadding';
import { Divider } from '@/components/Divider';
import { Header } from './components/Header';
import { List } from './components/List';
import { useGetUserContractFund } from './hooks/useGetUserContractFund';

export const AutoInvest: FC = () => {
  const { isError, isLoading } = useGetUserContractFund({ enabled: false });

  if (isError || isLoading) {
    return null;
  }
  return (
    <>
      <Divider height={8} />
      <HorizontalPaddingLayout className="py-4">
        <Header />
        <Divider className="my-2" />
        <List />
      </HorizontalPaddingLayout>
    </>
  );
};
